import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Loader } from "@/components";
import { useAuthToken } from "@/providers/context";
import { useAppProperties } from "@/hooks";

export const PurchaseSuccessScreen = () => {
  const navigate = useNavigate();
  const { refresh } = useAuthToken();
  const { redirectPurchaseSuccessURL } = useAppProperties();

  useEffect(() => {
    // Refresh Users Token with updated products following their purchase
    refresh({
      onSettled: () => {
        if (redirectPurchaseSuccessURL) {
          setTimeout(() => {
            // Give a delay for token refresh to finalize
            window.location.href = redirectPurchaseSuccessURL;
          }, 300);
        } else {
          navigate("/");
        }
      },
    });
  }, [navigate, refresh, redirectPurchaseSuccessURL]);

  return (
    <div className="flex h-full w-full items-center justify-center pr-[200px]">
      <Loader className="text-item-secondary h-10 w-10" />
    </div>
  );
};
